module.exports = __webpack_public_path__ + "img/4a3d5e604823ed12a8f10ae2bd80b266.svg";